// extracted by mini-css-extract-plugin
export default {"root":"IconEye_root__x9Q+-","pencil":"IconEye_pencil__ELy5n"};